import React from "react";
import { Link } from "react-router";
import { Layout, Drawer } from "antd";
import Checkout from '../../containers/JoinRace/Checkout';
import PropTypes from "prop-types";
import Helmet from 'react-helmet';
import * as MetaConstants from '../../common/constants/metatags';
import env from '../constants/environment';

const { Header } = Layout;

class Sidebar extends React.Component {
  state = { visible: false, placement: "left" };

  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  onChange = (e) => {
    this.setState({
      placement: e.target.value,
    });
  };

  render() {
    const { placement, visible } = this.state;
    const { user } = this.props;
    const { profile } = user;
    const selectEventTypeFilter = this.props.selectEventTypeFilter;
    return (
      <>
        <Helmet
          title='Virtual Races, Fitness Challenges and Exercise | Yes.Fit'
          meta={[
            { 'charset': 'utf-8' },
            { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge,chrome=1' },
            { name: 'description', content: MetaConstants.metaDesc },
            { name: 'viewport', content: MetaConstants.metaViewport },
            { name: 'twitter:card', content: MetaConstants.twitterCardType },
            { name: 'twitter:image', content: MetaConstants.twitterImage },
            { name: 'twitter:image:alt', content: MetaConstants.metaDesc },
            { name: 'twitter:site', content: MetaConstants.twitterHandle },
            { property: 'og:url', content: MetaConstants.metaUrl },
            { property: 'og:image', content: MetaConstants.ogImage },
            { property: 'og:title', content: MetaConstants.ogTitle },
            { property: 'og:locale', content: MetaConstants.ogLocale },
            { property: 'og:type', content: MetaConstants.ogType },
            { property: 'og:site_name', content: MetaConstants.ogSiteName },
            { property: 'og:description', content: MetaConstants.metaDesc },
            { property: 'fb:app_id', content: MetaConstants.fbAppId }
          ]}
          link={[
            { rel: 'canonical', href: MetaConstants.metaUrl }
          ]}
        />
        <Header className="mobile header-wrapper">
          <div
            className="scrollable-container"
            ref={(node) => {
              this.container = node;
            }}
          >
            <div className="main-header-left">
              <img
                className="sidebar-menu-icon"
                onClick={this.showDrawer}
                width="50"
                height="50"
                alt="Hamburger Menu"
                title="open Nav Menu"
                src="https://asset.yes.fit/homepage/Collapse+Menu.svg"
              />
              <a href="/" title="Go to Yes.Fit Home" className="logo-ada-focus">
                <img
                  className="top-text--logo"
                  width="50"
                  height="50"
                  alt="Yes.Fit Header Logo"
                  title="Go to Yes.Fit Home"
                  src="https://asset.yes.fit/homepage/yf-logo-web.png"
                />
              </a>
            </div>

            <Drawer
              title={
                <img
                  className="top-text--logo"
                  width="50"
                  height="50"
                  alt="Yes.Fit Header Logo"
                  title="Go to Yes.Fit Home"
                  src="https://asset.yes.fit/homepage/yf-logo-web.png"
                />
              }
              placement={placement}
              closable={false}
              onClose={this.onClose}
              visible={visible}
              key={placement}
            >
              <ul className="sidebar-menu-list">
                <li>
                  <a href={`${env.WEB_NEXT_URL}`} className="sidebar-link">
                    <img
                      src="https://asset.yes.fit/homepage/home-sidebar.svg"
                      className="sidebar-img"
                    />
                    Home
                  </a>
                </li>
                <li>
                  <a href={`${env.WEB_NEXT_URL}/exercises`} className="sidebar-link">
                    <img
                      src="https://asset.yes.fit/homepage/events-icon.svg"
                      className="sidebar-img"
                    />
                    Exercises
                  </a>
                </li>
                <li>
                  <a href={`${env.WEB_NEXT_URL}/races`} className="sidebar-link">
                    <img
                      src="https://asset.yes.fit/homepage/races-sidebar.svg"
                      className="sidebar-img"
                    />
                    Races
                  </a>
                </li>
                <li>
                  <a href={`${env.WEB_NEXT_URL}/challenges`}
                    className="sidebar-link"
                  >
                    <img
                      src="https://asset.yes.fit/homepage/challenges-sidebar.svg"
                      className="sidebar-img"
                    />
                    Challenges
                  </a>
                </li>
                <li>
                  <a href={`${env.WEB_NEXT_URL}/store`} className="sidebar-link">
                    <img
                      src="https://asset.yes.fit/homepage/shopping-cart-sidebar.svg"
                      className="sidebar-img"
                    />
                    Store
                  </a>
                </li>
                <li>
                  <a
                    href="https://help.yes.fit/en/"
                    className="sidebar-link"
                    target="_blank"
                  >
                    <img
                      src="https://asset.yes.fit/homepage/help-web-button-sidebar.svg"
                      className="sidebar-img"
                    />
                    FAQ
                  </a>
                </li>
                <li>
                  <Link to="/community" className="sidebar-link">
                    <img
                      src="https://asset.yes.fit/homepage/group-sidebar.svg"
                      className="sidebar-img"
                    />
                    Community
                  </Link>
                </li>
                <li>
                  <a href={`${env.WEB_NEXT_URL}/blog`}
                    target="_blank"
                    className="sidebar-link"
                  >
                    <img
                      src="https://asset.yes.fit/homepage/writing-sidebar.svg"
                      className="sidebar-img"
                    />
                    Blog
                  </a>
                </li>
                <li>
                  <Link to="/gift" className="sidebar-link">
                    <img
                      src="https://asset.yes.fit/homepage/discount-sidebar.svg"
                      className="sidebar-img"
                    />
                    Gift Vouchers
                  </Link>
                </li>
                <li>
                  <Link to="/corporate-wellness" className="sidebar-link">
                    <img
                      src="https://asset.yes.fit/homepage/portfolio-sidebar.svg"
                      className="sidebar-img"
                    />
                    Corp. Wellness
                  </Link>
                </li>
                <li>
                  <a href={`${env.WEB_NEXT_URL}/vip`} className="sidebar-link">
                    <img
                      src="https://asset.yes.fit/homepage/cyf-sidebar.svg"
                      className="sidebar-img"
                    />
                    VIP Membership
                  </a>
                </li>
                {profile.isAuthenticated && (
                  <>
                    <p className="links-section-title">Your Links</p>
                    <li>
                      <Link to={`/dashboard`} className="sidebar-link">
                        <img
                          src="https://asset.yes.fit/homepage/dashboard.svg"
                          className="sidebar-img"
                        />
                        Dashboard
                      </Link>
                    </li>
                    <li>
                      <a href={`${env.WEB_NEXT_URL}/dashboard-new`} className="sidebar-link">
                        <img
                          src="https://asset.yes.fit/homepage/dashboard.svg"
                          className="sidebar-img"
                        />
                        NEW Dashboard
                      </a>
                    </li>
                    <li>
                      <Link
                        to={"/my-orders"}
                        className="sidebar-link"
                      >
                        <img
                          src="https://asset.yes.fit/homepage/shopping-cart-sidebar.svg"
                          className="sidebar-img"
                        />
                        My Orders
                      </Link>
                    </li>
                    <li>
                      <Link to={"/groups"} className="sidebar-link">
                        <img
                          src="https://asset.yes.fit/homepage/group-sidebar.svg"
                          className="sidebar-img"
                        />
                        My Groups
                      </Link>
                    </li>
                    <li>
                      <Link to={`/achievements`} className="sidebar-link">
                        <img
                          src="https://asset.yes.fit/homepage/achievement-icon.svg"
                          className="sidebar-img"
                          style={{ marginLeft: -3, paddingRight: 7 }}
                        />
                        Achievements
                      </Link>
                    </li>
                    <li>
                      <Link to={`/social`} className="sidebar-link">
                        <img
                          src="https://asset.yes.fit/homepage/sticky-notes-sidebar.svg"
                          className="sidebar-img"
                        />
                        Social
                      </Link>
                    </li>
                    <li>
                      <Link to={`/profile`} className="sidebar-link">
                        <img
                          src="https://asset.yes.fit/homepage/user-sidebar.svg"
                          className="sidebar-img"
                        />
                        Profile
                      </Link>
                    </li>
                    <li>
                      <Link to={"/change-password"} className="sidebar-link">
                        <img
                          src="https://asset.yes.fit/homepage/lock.svg"
                          className="sidebar-img"
                        />
                        Change Password
                      </Link>
                    </li>
                  </>
                )}
                {profile.isAuthenticated && (
                  <li>
                    <Link
                      to="/"
                      className="sidebar-link logout"
                      onClick={() => this.props.logout()}
                    >
                      <img
                        src="https://asset.yes.fit/homepage/log-out.svg"
                        className="sidebar-img"
                      />
                      Logout
                    </Link>
                  </li>
                )}
                {!profile.isAuthenticated && (
                  <li>
                    <a href={`${env.WEB_NEXT_URL}/login`} className="sidebar-link">
                      <img
                        src="https://asset.yes.fit/homepage/lock.svg"
                        className="sidebar-img"
                      />
                      Login
                    </a>
                  </li>
                )}
                {profile.isAuthenticated && (
                  <>
                    <p className="links-section-title-danger">Danger</p>
                    <li>
                      <Link to={`/delete-request`} className="sidebar-link">
                        <img
                          src="https://asset.yes.fit/homepage/dashboard.svg"
                          className="sidebar-img"
                        />
                        Delete My Account
                      </Link>
                    </li>
                  </>
                )}
              </ul>
            </Drawer>
          </div>
          <Checkout type="checkout" />
          <Checkout type="start-over" />
        </Header>
      </>
    );
  }
}

Sidebar.propTypes = {
  selectEventTypeFilter: PropTypes.func.isRequired,
};
export default Sidebar;
